export const SITE = {
  name: "Shine and Drive",
  fullName: "Shine and Drive Car Cleaning",
  tagline: "Premium hand-detailing in North Seattle",
  bookingUrl:
    "https://app.squareup.com/appointments/book/cjy0pa6yi9e2fp/LD1TY3A3KFZMV/start",
  area: "Pinehurst / Northgate · Northeast Seattle",
  email: "seanmurphylemoine@gmail.com",
  phone: "(206) 565-4993",
  phoneRaw: "2065654993",
  hours: "Weekends & after-school · By appointment",
  socials: {
    instagram: {
      handle: "@shine.and.drive.seattle",
      url: "https://www.instagram.com/shine.and.drive.seattle/",
    },
    facebook: {
      handle: "Shine & Drive on Facebook",
      url: "https://www.facebook.com/share/1B8gKfUnE6/?mibextid=wwXIfr",
    },
  },
  services: [
    {
      id: "quick-refresh",
      name: "Quick Refresh",
      price: 90,
      duration: "~2 hrs",
      tagline: "Routine upkeep, fast turnaround.",
      description:
        "A fast, no-frills interior clean to bring your car back to a tidy, comfortable state. Perfect for routine upkeep.",
      features: [
        "Interior vacuum",
        "Wipe-down of all surfaces",
        "Interior window cleaning",
        "Trash removal",
      ],
      image:
        "https://images.unsplash.com/photo-1621639532859-8b26570b96fc?auto=format&fit=crop&w=1400&q=80",
    },
    {
      id: "interior-revival",
      name: "Interior Revival",
      price: 150,
      duration: "~4–5 hrs",
      popular: true,
      tagline: "Most popular — a true reset.",
      description:
        "Our most requested package — designed to give your car a noticeably refreshed, more deeply cleaned interior.",
      features: [
        "Everything in Quick Refresh",
        "Dash, vents, panels & cupholders detailed",
        "Deeper interior vacuum",
        "Carpets & mats deep cleaned",
        "Light stain removal",
      ],
      excluded: [
        "Deep crevice cleaning",
        "Door jams",
        "Deep vacuuming under the mats",
        "Seat rails",
      ],
      image:
        "https://static.prod-images.emergentagent.com/jobs/d90791ad-db5d-442d-bf9b-11f555362e82/images/326df82a3e73caec8040c37e02454057b438f10f2f4eddcad2ac54fb5d713a04.png",
    },
    {
      id: "the-works",
      name: "The Works",
      subtitle: "Full Interior Detail + External Wash",
      price: 275,
      duration: "~7–8 hrs",
      tagline: "The full treatment. Like-new finish.",
      description:
        "A high-detail, like-new interior finish for vehicles that need a little extra attention — inside and out.",
      features: [
        "Everything in Interior Revival",
        "Carpet + seat shampoo",
        "Steam cleaning",
        "Fine-detail brush work",
        "Deep stain treatment",
        "Headlight restoration",
        "Exterior handwash + microfiber dry",
      ],
      excluded: [
        "Ceramic coating",
        "Wax / paint sealant",
        "Clay bar / decontamination",
      ],
      image:
        "https://static.prod-images.emergentagent.com/jobs/d90791ad-db5d-442d-bf9b-11f555362e82/images/e580f57e6f91c5fd8fa1cb1f74ac04a9c1b460fbae3fe1fcc392199f23bcc411.png",
    },
  ],
  addons: [
    {
      name: "Exterior Handwash & Microfiber Towel-Dry",
      note: "No wax or ceramic coatings",
      price: 40,
    },
    {
      name: "Pet Fur / Dirt / Odor Treatment",
      note: "For heavier interior buildup",
      price: 40,
    },
    {
      name: "Mobile Detail — We Come to You",
      note: "Serving Northeast Seattle only",
      price: 50,
    },
  ],
  // Real before/after pairs uploaded by the owner (locally hosted, mobile-optimized)
  beforeAfter: [
    {
      before: "/images/ba/before_1.jpg",
      after: "/images/ba/after_1.jpg",
      caption: "Subaru — Interior Revival",
    },
    {
      before: "/images/ba/before_2.jpg",
      after: "/images/ba/after_2.jpg",
      caption: "Hyundai Ioniq 5 — Interior Detail",
    },
    {
      before: "/images/ba/before_3.jpg",
      after: "/images/ba/after_3.jpg",
      caption: "Subaru Sport — Full Interior Detail",
    },
  ],
  // Real testimonials (real reviews from customers + placeholders pending replacement)
  testimonials: [
    {
      quote:
        "Shout out to my guy from SHINE AND DRIVE! I just took my car there as I haven't been able to get a detail clean for the past 3 years and he was able to make it look new like when I first bought my car in 2021! Thank you — it truly means a lot to us!",
      name: "Cristobal Tolentino Jr.",
      detail: "Pinehurst Seattle · via Facebook",
      featured: true,
    },
    {
      quote:
        "Honestly didn't think the car could look this good again. They got stains out I'd given up on.",
      name: "Sarah K.",
      detail: "Northgate · Interior Revival",
    },
    {
      quote:
        "Super easy drop-off, finished on time, and the price beats every shop in Seattle I checked.",
      name: "Marcus T.",
      detail: "Pinehurst · The Works",
    },
    {
      quote:
        "These guys clearly care. Came back to a car that smelled and felt brand new.",
      name: "Priya R.",
      detail: "Maple Leaf · Interior Revival",
    },
  ],
  referral: {
    amount: 20,
    code: "REFER20",
    message:
      "I just got my car detailed by Shine & Drive — they're awesome. Use code REFER20 for $20 off your first detail.",
  },
  media: {
    hero: "https://static.prod-images.emergentagent.com/jobs/d90791ad-db5d-442d-bf9b-11f555362e82/images/7172265f643acc42d358090e6b783512c5228ca1a4b51d4770e7d7e47b0a2f3f.png",
    about: "https://images.pexels.com/photos/14231684/pexels-photo-14231684.jpeg",
    leather:
      "https://static.prod-images.emergentagent.com/jobs/d90791ad-db5d-442d-bf9b-11f555362e82/images/486b9150336e36965446eeebacf047a18a4772c7bf475328849c0b42bc3dcecc.png",
    founders: "/images/founders.jpg",
    logo: "/images/logo.png",
  },
};
